/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1CustomersubgroupsQueryResponse } from '../../types/GetV1Customersubgroups.ts'

export const getV1CustomersubgroupsQueryKey = () => [{ url: '/v1/CustomerSubGroups' }] as const

export type GetV1CustomersubgroupsQueryKey = ReturnType<typeof getV1CustomersubgroupsQueryKey>

/**
 * {@link /v1/CustomerSubGroups}
 */
export async function getV1Customersubgroups(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1CustomersubgroupsQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/CustomerSubGroups`, ...requestConfig })
    return res
}

export function getV1CustomersubgroupsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1CustomersubgroupsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1CustomersubgroupsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1CustomersubgroupsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Customersubgroups(config)
        },
    })
}

/**
 * {@link /v1/CustomerSubGroups}
 */
export function useGetV1Customersubgroups<
    TData = ResponseConfig<GetV1CustomersubgroupsQueryResponse>,
    TQueryData = ResponseConfig<GetV1CustomersubgroupsQueryResponse>,
    TQueryKey extends QueryKey = GetV1CustomersubgroupsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1CustomersubgroupsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1CustomersubgroupsQueryKey()

    const query = useQuery(
        {
            ...getV1CustomersubgroupsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
